// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-757b1082] .accent-column {\n  background-color: #fafbfc;\n}\ntd.has-property[data-v-757b1082] {\n  border-left: 1px solid rgb(238, 238, 238);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
